import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/generate", "documento": "invoices", "acceso": "sesion", "filas": ["023"], "cita": "prod:Areas/Invoices/Controllers/GenerateController.cs:20"} satisfies RutaProd;
